<template>
  <div class="page_wrapper container-fluid job_opening_area">
    <div class="row page_header job_opening_header">
      <job-opening-header
        :current-breadcrumb-items="jobOpeningBreadcrumb"
        title="職缺搜尋"
      />
    </div>
    <div class="row job_opening_content">
      <job-opening-enterprise-content />
    </div>
  </div>
</template>
<script>
import JobOpeningHeader from '~components/pages/job-opening/JobOpeningHeader'
import JobOpeningEnterpriseContent from '~components/pages/job-opening/JobOpeningEnterpriseContent'
export default {
  name: 'JobOpeningZhEnterprise',
  routerName: 'Job-openingZh:idEnterprise',
  components: {
    JobOpeningHeader,
    JobOpeningEnterpriseContent
  },
  data: function () {
    return {
      jobOpeningBreadcrumb: [
        {
          text: '首頁',
          path: '/'
        },
        {
          text: '職缺搜尋',
          path: '/job-opening/zh'
        },
        {
          text: '公司介紹'
        }
      ]
    }
  }
}
</script>
